import {
  LanguageConfig,
  MessageStepConfig,
  MessageWhatsappTemplateType,
} from 'config/CustomEnums';

export const CreateMessageError = {
  messageTemplate: {
    name: 'messageTemplate',
    message: 'Please provide a message template.',
  },
  name: {
    name: `name`,
    message: 'Please provide a name.',
  },
  channels: {
    name: 'channels',
    message: 'Please provide channels.',
  },
  // push and inbox
  titleLengthLimit: {
    name: `translations.${LanguageConfig.english}.name`,
    message: 'Title limit 200 characters.',
  },
  content: {
    name: `translations.${LanguageConfig.english}.content`,
    message: 'Please provide a content.',
  },
  // email
  emailTitle: {
    name: `translations.${LanguageConfig.english}.emailTitle`,
    message: 'Please provide a title.',
  },
  emailTitleLengthLimit: {
    name: `translations.${LanguageConfig.english}.emailTitle`,
    message: 'Email title limit 200 characters.',
  },
  emailContent: {
    name: `translations.${LanguageConfig.english}.emailContent`,
    message: 'Please provide a content.',
  },
  // sms
  smsContent: {
    name: `translations.${LanguageConfig.english}.smsContent`,
    message: 'Please provide a content.',
  },

  scheduledDate: {
    name: 'scheduledDate',
    message: 'Please provide a valid schedule time.',
  },
};

function firstStepValidate({ getValues, errorList }) {
  const [channels, isStartWithTemplate, messageTemplate, name] = getValues([
    'channels',
    'isStartWithTemplate',
    'messageTemplate',
    'name',
  ]);
  const validateErrorList = [];
  if (channels == null || channels.length === 0) {
    validateErrorList.push({
      name: CreateMessageError.channels.name,
      message: CreateMessageError.channels.message,
    });
  }
  if (isStartWithTemplate && !messageTemplate?.value?.pk) {
    validateErrorList.push({
      name: CreateMessageError.messageTemplate.name,
      message: CreateMessageError.messageTemplate.message,
    });
  }

  if (!name) {
    validateErrorList.push({
      name: CreateMessageError.name.name,
      message: CreateMessageError.name.message,
    });
  }

  errorList.push(...validateErrorList);

  return !validateErrorList.length;
}

export function secondPushStepValidate({ getValues, errorList, additionalFieldName = "" }) {
  const [content, translations] = getValues([
    `${additionalFieldName}translations.${LanguageConfig.english}.content`,
    `${additionalFieldName}translations`,
  ]);

  const validateErrorList = [];
  if (!content) {
    validateErrorList.push({
      name: `${additionalFieldName}${CreateMessageError.content.name}`,
      message: CreateMessageError.content.message,
    });
  }

  for (const [languageCode, translation] of Object.entries(translations || {})) {
    const translationName = translation?.name;
    if (translationName?.length > 200) {
      validateErrorList.push({
        name: `${additionalFieldName}translations.${languageCode}.name`,
        message: CreateMessageError.titleLengthLimit.message,
      });
    }
  }

  errorList.push(...validateErrorList);

  return !validateErrorList.length;
}

export function secondEmailStepValidate({ getValues, errorList, additionalFieldName = "" }) {
  const [title, content, translations] = getValues([
    `${additionalFieldName}translations.${LanguageConfig.english}.emailTitle`,
    `${additionalFieldName}translations.${LanguageConfig.english}.emailContent`,
    `${additionalFieldName}translations`,
  ]);
  const validateErrorList = [];
  if (!title) {
    validateErrorList.push({
      name: `${additionalFieldName}${CreateMessageError.emailTitle.name}`,
      message: CreateMessageError.emailTitle.message,
    });
  }
  if (!content) {
    validateErrorList.push({
      name: `${additionalFieldName}${CreateMessageError.emailContent.name}`,
      message: CreateMessageError.emailContent.message,
    });
  }
  for (const [languageCode, translation] of Object.entries(translations || {})) {
    const translationTitle = translation?.emailTitle;
    if (translationTitle?.length > 200) {
      validateErrorList.push({
        name: `${additionalFieldName}translations.${languageCode}.emailTitle`,
        message: CreateMessageError.emailTitleLengthLimit.message,
      });
    }
  }

  errorList.push(...validateErrorList);

  return !validateErrorList.length;
}

export function secondSmsStepValidate({ getValues, errorList, additionalFieldName = "" }) {
  const [content] = getValues([
    `${additionalFieldName}translations.${LanguageConfig.english}.smsContent`,
  ]);
  const validateErrorList = [];
  if (!content) {
    validateErrorList.push({
      name: `${additionalFieldName}${CreateMessageError.smsContent.name}`,
      message: CreateMessageError.smsContent.message,
    });
  }

  errorList.push(...validateErrorList);

  return !validateErrorList.length;
}

export function secondWhatsappStepValidate({ getValues, errorList, additionalFieldName = "" }) {
  const [translations] = getValues([
    `${additionalFieldName}translations`,
  ]);
  for (const [language, translation] of Object.entries(translations || {})) {
    const [template, photo, headerArgs, bodyArgs] = getValues([
      `${additionalFieldName}translations.${language}.whatsappTemplate`,
      `${additionalFieldName}translations.${language}.whatsappImage`,
      `${additionalFieldName}translations.${language}.whatsappHeader`,
      `${additionalFieldName}translations.${language}.whatsappBody`,
    ]);
    if (language === LanguageConfig.english) {
      if (!template) {
        errorList.push({
          name: `${additionalFieldName}translations.${language}.whatsappTemplate`,
          message: 'Please select template',
        })
        return false;
      }
    }
    if (
      template?.headerFormat === MessageWhatsappTemplateType.IMAGE &&
      !photo
    ) {
      errorList.push({
        name: `${additionalFieldName}translations.${language}.whatsappImage`,
        message: 'Please upload Image',
      })
      return false;
    }
    if (template?.headerFormat === MessageWhatsappTemplateType.TEXT) {
      const fieldCount = template?.headerText?.split(/{{\d+}}/)?.length - 1;
      if (fieldCount > 0) {
        for (let i = 0; i < fieldCount; i++) {
          const value = headerArgs?.[i];
          if (!value) {
            errorList.push({
              name: `${additionalFieldName}translations.${language}.whatsappHeader.${i}`,
              message: 'mandatory field',
            })
            return false;
          }
        }
      }
    }
    const fieldCount = template?.bodyText?.split(/{{\d+}}/)?.length - 1;
    if (fieldCount > 0) {
      for (let i = 0; i < fieldCount; i++) {
        const value = bodyArgs?.[i];
        if (!value) {
          errorList.push({
            name: `${additionalFieldName}translations.${language}.whatsappBody.${i}`,
            message: 'mandatory field',
          })
          return false;
        }
      }
    }
  }
  return true;
}

function thirdStepValidate({ getValues, errorList }) {
  const [scheduledDate] = getValues(["scheduledDate"]);
  if (!scheduledDate || new Date(scheduledDate) < new Date()) {
    errorList.push({
      name: CreateMessageError.scheduledDate.name,
      message: CreateMessageError.scheduledDate.message,
    });
  }

  return !errorList.length;
}

export function validate({
  getValues,
  setError,
  clearErrors,
  step,
  isBack,
  languages,
}) {
  if (isBack) {
    return true;
  }
  clearErrors();
  const errorList = [];
  switch (step) {
    case 0:
      const validStepOne = firstStepValidate({ getValues, errorList });
      errorList.forEach((error) => {
        setError(error.name, {
          type: 'require',
          message: error.message,
        });
      });
      console.log('errorListMessage:', errorList);
      return validStepOne;
    case 1:
      const validStepTwoPush = secondPushStepValidate({ getValues, errorList });
      errorList.forEach((error) => {
        setError(error.name, {
          type: 'require',
          message: error.message,
        });
      });
      console.log('errorListMessage:', errorList);
      return validStepTwoPush;
    case 2:
      const validStepTwoEmail = secondEmailStepValidate({
        getValues,
        errorList,
      });
      errorList.forEach((error) => {
        setError(error.name, {
          type: 'require',
          message: error.message,
        });
      });
      console.log('errorListMessage:', errorList);
      return validStepTwoEmail;
    case 3:
      const validStepTwoSMS = secondSmsStepValidate({ getValues, errorList });
      errorList.forEach((error) => {
        setError(error.name, {
          type: 'require',
          message: error.message,
        });
      });
      console.log('errorListMessage:', errorList);
      return validStepTwoSMS;
    case 4:
      const validStepTwoWhatsapp = secondWhatsappStepValidate({
        getValues,
        errorList,
      });
      errorList.forEach((error) => {
        setError(error.name, {
          type: 'require',
          message: error.message,
        });
      });
      console.log('errorListMessage:', errorList);
      return validStepTwoWhatsapp;
    case 5:
      const validStepThree = thirdStepValidate({ getValues, errorList });
      errorList.forEach((error) => {
        setError(error.name, {
          type: 'require',
          message: error.message,
        });
      });
      console.log('errorListMessage:', errorList);
      return validStepThree;
    default:
      let validResult = true;
      const channels = getValues(['channels']);
      const validOne = firstStepValidate({ getValues, errorList });
      validResult = validResult && validOne;
      if (MessageStepConfig[1].show(channels)) {
        const validTwoPush = secondPushStepValidate({ getValues, errorList });
        validResult = validResult && validTwoPush;
      }
      if (MessageStepConfig[2].show(channels)) {
        const validTwoEmail = secondEmailStepValidate({ getValues, errorList });
        validResult = validResult && validTwoEmail;
      }
      if (MessageStepConfig[3].show(channels)) {
        const validTwoSms = secondSmsStepValidate({ getValues, errorList });
        validResult = validResult && validTwoSms;
      } else if (MessageStepConfig[4].show(channels)) {
        const validTwoWhatsapp = secondWhatsappStepValidate({
          getValues,
          errorList,
        });
        validResult = validResult && validTwoWhatsapp;
      }
      const validThree = thirdStepValidate({ getValues, errorList });
      validResult = validResult && validThree;
      errorList.forEach((error) => {
        setError(error.name, {
          type: 'require',
          message: error.message,
        });
      });
      console.log('errorListMessage:', errorList);
      return validResult;
  }
}
